import { numberFormat } from '@libs/core';
import { AssetsSvgMap, TCalculatorBonus } from '@libs/types';
import React, { MouseEventHandler } from 'react';
import { VisualView } from '../../Image/VisualView';
import { FeeBlock } from './FeeBlock';

type TFeePanelProps = {
    bonus: TCalculatorBonus;
    label: string;
    onClick?: MouseEventHandler;
    parentStyleNames?: string[];
};

const Bonus = React.memo(({ bonus, label, onClick, parentStyleNames }: TFeePanelProps) => {
    const prefix = (() => {
        switch (bonus.direction) {
            case 'PLUS':
                return '+';
            case 'MINUS':
                return '-';
            default:
                return '';
        }
    })();

    return (
        <FeeBlock
            icon={
                bonus.iconName ? (
                    <VisualView
                        as="button"
                        uid="calculator_info_icon_bonus"
                        iconName={bonus.iconName}
                        defaultIconName={AssetsSvgMap.ic_x}
                        iconWidth={16}
                        iconHeight={16}
                        iconColor="var(--grey_72_lc)"
                        hovered={{ backgroundColor: 'var(--grey_16_lc)' }}
                        parentStyleNames={parentStyleNames}
                        styleName="calculatorInfoIcon"
                        handleClick={onClick}
                        margin={{ left: 6 }}
                    />
                ) : null
            }
            title={label ?? ''}
            text={`${prefix}${numberFormat(bonus.sum) as string} ${bonus.currency?.toUpperCase()}`}
            textColor="var(--purple_100)"
            parentStyleNames={parentStyleNames}
        />
    );
});
export { Bonus };
